import React from "react";

// A cheap, STATIC map thumbnail: just the arena shape, sized by the map's actual
// dimensions so Small/Large/Huge are visually distinct. No game loop, no random
// doodles — the live game renders in the arena once a match starts.
export interface MapOption {
  value: string;
  name: string;
  shape: "square" | "circle";
  size: number; // 500 | 800 | 1000 ...
}

export default function StaticMapTile({ map, selected, onClick }: { map: MapOption; selected: boolean; onClick: () => void }) {
  const fill = map.size >= 1000 ? 0.98 : map.size >= 800 ? 0.78 : 0.56; // bigger map → bigger shape
  const s = 100 * fill;
  const off = (100 - s) / 2;
  const stroke = selected ? "#28c4d4" : "rgba(255,255,255,0.32)";
  const interior = selected ? "rgba(40,196,212,0.06)" : "rgba(255,255,255,0.02)";
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 8,
        padding: 10,
        borderRadius: 12,
        cursor: "pointer",
        background: selected ? "rgba(40,196,212,0.12)" : "rgba(255,255,255,0.03)",
        border: selected ? "1.5px solid #28c4d4" : "1.5px solid rgba(255,255,255,0.08)",
        color: "#eaf0ff",
      }}
    >
      <svg viewBox="0 0 100 100" width="100%" style={{ display: "block", maxWidth: 120 }}>
        {map.shape === "circle" ? (
          <circle cx="50" cy="50" r={s / 2} fill={interior} stroke={stroke} strokeWidth="2.5" />
        ) : (
          <rect x={off} y={off} width={s} height={s} rx="7" fill={interior} stroke={stroke} strokeWidth="2.5" />
        )}
      </svg>
      <span style={{ fontFamily: '"Orbitron", sans-serif', fontWeight: 700, fontSize: 12, letterSpacing: 0.5 }}>{map.name}</span>
    </button>
  );
}
